import React from "react";
import { ScrollTemplates } from "../ScrollTemplates";
import { SearchInput } from "../SearchInput";
import { ContainerSidebarNav } from "../Sidebar/components/ContainerSidebar/styles";
import TemplatesList from "./components/TemplateList";
import { FlexSearch, VerticalStack, WrapperButtonFeedback } from "./styles";

// import { Container } from './styles';

interface ITemplatesViewProps {
  search?: string;
  setSearch?: React.Dispatch<React.SetStateAction<string>>;
}

const TemplatesView: React.FC<ITemplatesViewProps> = ({
  search,
  setSearch
}) => {
  return (
    <ContainerSidebarNav scroll={"hidden"} padding="0 0.2rem">
      <VerticalStack>
        <ScrollTemplates text="Tipo de contrato" />
        <WrapperButtonFeedback>
          <button
            onClick={() =>
              window.open("https://bitsacademy.typeform.com/templateuxdoc")
            }
          >
            Não encontrou o template que queria? Deixe aqui a sua sugestão.
          </button>
        </WrapperButtonFeedback>
      </VerticalStack>
    </ContainerSidebarNav>
  );
};

export default TemplatesView;
